import Vue from 'vue'
// export const EventBus = new Vue({ el: '#app' }) <-- in this case access using import { EventBus }
export default new Vue({
  data: {
    info: {
      xth: '20th',
      year: 2026,
      date: 'May 8-9, 2026',
      countdown: 'Fri May 8 2026 17:00:00 GMT-0400',
      countdownSignUp: 'Mon Jan 17 2026 00:00:00 GMT-0400'
      // countdownSignUp: 'Thu Dec 30 2021 13:13:50 GMT+0800'
    },
    _isDesktop: true,
    _windowWidth: 1024,
    _navMain: [
      {
        name: 'teams',
        title: 'Signup & 2026 Teams',
        path: '/info'
      }, {
        name: 'schedule',
        title: 'Events & Schedule',
        path: '/schedule'
      // }, {
      //   name: 'photos',
      //   title: 'Photos',
      //   path: '#',
      //   section: 'section-photo'
      }, {
        name: 'photos',
        title: 'Photos',
        path: '/photos'
      }, {
        name: 'sponsors',
        title: 'Sponsors',
        path: '/sponsors'
        // path: '#',
        // section: 'section-sponsors'
      }
    ],
    _navSocial: [
      {
        name: 'facebook',
        fa: 'facebook',
        path: 'https://www.facebook.com/bosshogcookoff'
      }, {
        name: 'twitter',
        fa: 'twitter',
        path: 'https://www.twitter.com/bosshogcookoff'
      }, {
        name: 'instagram',
        fa: 'instagram',
        path: 'https://www.instagram.com/bosshogcookoff'
      }
    ],
    _navInstagram: {
      title: 'BossHogCookOff',
      path: 'https://www.instagram.com/bosshogcookoff'
    },
    _navInstagramHashtag: {
      title: '#bosshogcookoff',
      path: 'https://www.instagram.com/explore/tags/bosshogcookoff/'
    },
    _navYoutube: {
      title: 'BossHogCookOff',
      path: 'https://www.youtube.com/bosshogcookoff'
    },
    _navTwitter: {
      title: 'BossHogCookOff',
      path: 'https://www.twitter.com/bosshogcookoff'
    },
    _navFacebook: {
      title: 'BossHogCookOff',
      path: 'https://www.facebook.com/bosshogcookoff'
    },
    _navLocation: {
      title: 'Schwank Way, Waynesboro, GA 30830',
      path: 'https://maps.google.com/maps?daddr=33.100098,-81.999403&hl=en&ll=33.100022,-81.999604&spn=0.004013,0.004603&sll=33.099289,-81.999807&sspn=0.016052,0.018132&t=m&mra=mift&mrsp=1&sz=16&z=18'
    },
    _navEmail: 'nlynch@fnbwaynesboro.com'
  },
  computed: {
    isDesktop: {
      get: function () {
        return this._isDesktop
      },
      set: function (isDesktop) {
        if (this._isDesktop !== isDesktop) {
          // do not update immediately, only change if necessary
          this._isDesktop = isDesktop
          this.$emit('isDesktopChanged', isDesktop)
        }
      }
    },
    windowWidth: {
      get: function () {
        return this._windowWidth
      },
      set: function (windowWidth) {
        if (this._windowWidth !== windowWidth) {
          this._windowWidth = windowWidth
          this.$emit('windowWidthChanged', windowWidth)
        }
      }
    }
  },
  watch: {
  },
  methods: {
    isSignUp: function () {
      return false
      // return true
      // let countdownSignUp = this.info.countdownSignUp
      // let countdown = Math.trunc(Date.parse(countdownSignUp) / 1000)
      // let aday = (3600 * 24)
      // let now = Math.trunc((new Date()).getTime() / 1000)
      // console.log('-- sign up gap', { countdown, now, aday, gap: (countdown - now) })
      // // {countdown: 1642392000, now: 1642390711, aday: 86400, gap: 1289}
      // // now = 17 Jan 2022 11:39am (current +0800)
      // // countdown = 'Mon Jan 17 2022 00:00:00 GMT-0400'
      // // 1289 / 60 = 21 minutes
      // return (countdown - now - aday) < 0
    },

    detectIE: function () {
      /**
       * detect IE
       * returns version of IE or false, if browser is not Internet Explorer
       */
      var ua = window.navigator.userAgent

      // Test values; Uncomment to check result …

      // IE 10
      // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

      // IE 11
      // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

      // Edge 12 (Spartan)
      // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

      // Edge 13
      // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

      var msie = ua.indexOf('MSIE ')
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
      }

      var trident = ua.indexOf('Trident/')
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:')
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
      }

      var edge = ua.indexOf('Edge/')
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
      }

      // other browser
      return false
    }
  }
}) // <-- in this case access using import EventBus



// WEBPACK FOOTER //
// ./src/controllers/EventBus.js